import { useMsal } from '@azure/msal-react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import { useMe } from '../features/me/useMe';

/**
 * A főmenü a NÉGY OBJEKTUMTÍPUS köré szerveződik (D fázis, 3.1 pont):
 * Mappák, Raklapok, Lokációk (benne a polcok) — plusz a Címkék, ami
 * mindegyikhez tartozik. A „Keresés" beolvadt a Mappák oldalba: az volt a
 * mappalista, csak szűrők nélkül.
 */
const NAV = [
  { label: 'Mappák', to: '/mappak' },
  { label: 'Lokációk', to: '/lokaciok' },
  { label: 'Címkék', to: '/cimkek' },
  { label: 'Törzsadatok', to: '/torzsadatok' },
  { label: 'Eseménynapló', to: '/naplo' },
  { label: 'Ellenőrzés', to: '/ellenorzes' },
  { label: 'Fiók', to: '/fiok' },
];

/**
 * A közös keret: fejléc a bejelentkezett felhasználóval, fő navigáció és a
 * route-tartalom helye.
 *
 * A megjelenített nevet a BACKEND `GET /me` adja, nem az MSAL account
 * objektum — így az látszik, amit a szerver ténylegesen lát és naplóz.
 */
export function AppShell() {
  const { instance } = useMsal();
  const me = useMe();
  const { pathname } = useLocation();

  // A fül a leghosszabb illeszkedő útvonalat jelöli, hogy a részletező
  // oldalak (pl. /cimkek/abc) is a szülő fület emeljék ki.
  const active = NAV.map((n) => n.to)
    .filter((to) => pathname === to || pathname.startsWith(`${to}/`))
    .sort((a, b) => b.length - a.length)[0];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          {/*
            A logó FEHÉR HÁTTERŰ, a fejléc viszont a MUI elsődleges színe —
            ezért fehér, lekerekített alapra kerül. Átlátszóvá tenni nem
            lehetne biztonságosan: a logó fekete elemei sötét alapon
            eltűnnének.
          */}
          <Box
            component="img"
            src="/persped-logo.jpg"
            alt="Persped"
            sx={{ height: 28, bgcolor: 'common.white', borderRadius: 0.5, px: 0.5, mr: 1.5 }}
          />
          <Typography variant="h6" component="h1" sx={{ flexGrow: 1 }}>
            Irattár
          </Typography>
          {me.data && (
            <Typography variant="body2" sx={{ mr: 2 }}>
              {me.data.displayName} ({me.data.username})
            </Typography>
          )}
          <Button color="inherit" onClick={() => void instance.logoutRedirect()}>
            Kijelentkezés
          </Button>
        </Toolbar>

        <Tabs
          value={active ?? false}
          textColor="inherit"
          indicatorColor="secondary"
          sx={{ px: 2, bgcolor: 'primary.dark' }}
        >
          {NAV.map((item) => (
            <Tab key={item.to} label={item.label} value={item.to} component={RouterLink} to={item.to} />
          ))}
        </Tabs>
      </AppBar>

      <Container component="main" maxWidth="xl" sx={{ py: 3, flexGrow: 1 }}>
        <Outlet />
      </Container>
    </Box>
  );
}
